export default "__VITE_ASSET__DPSKRXeS__"